import React from 'react';
import { Dropdown } from '@carbon/react';

export default function DropdownControl(props) {
  return <Dropdown {...props} />;
}
